@if (!pageStore.canShowComponents()) {
  <ces-general-info-skeleton />
} @else if (pageStore.currentCampaign()) {
  <div class="flex gap-(--gap-loose) flex-col">
    @if (!isCampaignDone()) {
      <ces-button-secondary
        [hasPermission]="{ method: 'putCampaignDetailResource', assetId: pageStore.currentCampaign()?.assetId }"
        [label]="'common.buttons.edit' | transloco"
        size="small"
        icon="edit"
        [disabled]="pageStore.isLoading()"
        (onClick)="editCampaign()" />
    }

    <ces-property [label]="'common.labels.date' | transloco">{{
      pageStore.currentCampaign()?.timestamp | date: 'dd.MM.yyyy HH:mm'
    }}</ces-property>

    <hr />

    <ces-property [label]="'common.labels.operator' | transloco">{{ pageStore.currentCampaign()?.operator || '-' }}</ces-property>
    <ces-property [label]="'common.labels.comment' | transloco">{{ pageStore.currentCampaign()?.comment || '-' }}</ces-property>
  </div>
} @else {
  <div class="text-center text-(color:--text-secondary) italic py-(--space-8)">
    {{ 'entities.campaign.messages.loadError' | transloco }}
  </div>
}
